export default "__VITE_ASSET__DDcLMNSP__"